import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/login')({
  component: LoginLayout,
})

function LoginLayout() {
  return <Outlet />

  // return (
  //   <BankIdProvider>
  //     <Outlet />
  //   </BankIdProvider>
  // )
}
